import Icons from "../../../components/footer/components/Icons";
import { BsLinkedin, BsFacebook, BsInstagram } from "react-icons/bs";
import styled from "styled-components";

const SocialMedia = () => {
  return (
    <Div>
      <Icons
        Icon={BsInstagram}
        link="https://www.instagram.com/eratek.io/"
      />
      <Icons
        Icon={BsFacebook}
        link="https://www.facebook.com/profile.php?id=100091502844748&mibextid=ZbWKwL"
      />
      <Icons
        Icon={BsLinkedin}
        link="https://www.linkedin.com/company/era-tek/"
      />
    </Div>
  );
};

export default SocialMedia;

const Div = styled.div`
  display: flex;
  gap: 0.5rem;
`;
